import React from 'react';
import { Dropdown, DropdownMenu } from 'src/components/Common/reactstrap';

export default class DropdownMenus extends React.Component {
  constructor(props) {
    super(props);
    this.targetContent = props.targetContent;
    this.dropdownContent = props.dropdownContent;
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      dropdownOpen: nextProps.dropdownOpen
    });

  }
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <span
          onClick={this.toggle}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded={this.state.dropdownOpen}
        >
          {this.targetContent}
        </span>
        <DropdownMenu onClick={this.toggle}>
          {this.dropdownContent}
        </DropdownMenu>
      </Dropdown>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./src/components/Common/DropdownMenus.jsx
 **/